module.exports = __webpack_public_path__ + "20651a1549c6db739e609ed632768e6d.fbx";